export default "select *\nfrom assistants;";